import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53bf1288"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-12 content_main_wrap" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content_ls_margin" }, [
          /*#__PURE__*/_createElementVNode("h3", null, "No Access"),
          /*#__PURE__*/_createElementVNode("p", null, "You do not have access to this application.")
        ])
      ])
    ])
  ])
], -1))

export function render(_ctx, _cache) {
  const _component_StdPageLayout = _resolveComponent("StdPageLayout")

  return (_openBlock(), _createBlock(_component_StdPageLayout, null, {
    "body-content": _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}